<template>
  <div class="preference content-container flex-column">
    <!-- Pasek menu -->
    <div class="d-flex preference-section-container no-content">
      <div class="preference-section"></div>
      <div class="content-wrap">
        <TopMenu />
      </div>
    </div>

    <!-- Sekcja danych użytkownika -->
    <div class="d-flex preference-section-container">
      <div class="preference-section">
        <span>
          {{ t('user-data') }}
        </span>
      </div>
      <div class="content-wrap">
        <h3>{{ t('account-data') }}</h3>
        <div class="collapse show" id="userData">
          <div class="card-body">
            <!-- Formularz edycji danych użytkownika -->
            <Form
              @submit="onSubmit"
              :validation-schema="schema"
              v-slot="{ errors, isSubmitting }"
            >
              <!-- Pola imię, nazwisko, e-mail -->
              <div class="column d-flex justify-content-center">
                <div class="col-sm-6">
                  <!-- Imię -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('name') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="firstName"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.firstName }"
                        v-model="userData.firstName"
                      />
                      <div class="invalid-feedback">{{ errors.firstName }}</div>
                    </div>
                  </div>
                  <!-- Nazwisko -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('lastname') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="lastName"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.lastName }"
                        v-model="userData.lastName"
                      />
                      <div class="invalid-feedback">{{ errors.lastName }}</div>
                    </div>
                  </div>
                  <!-- Email -->
                  <div class="form-group row mb-3">
                    <label class="col-sm-4 col-form-label">{{ t('email') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="email"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.email }"
                        v-model="userData.email"
                      />
                      <div class="invalid-feedback">{{ errors.email }}</div>
                    </div>
                  </div>
                </div>
                <!-- Pola telefon, hasło -->
                <div class="col-sm-6 phone">
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('phone') }}:</label>
                    <div class="col-sm-2">
                      <Field
                        name="phoneNumberDir"
                        type="text"
                        class="form-control"
                        :disabled="true"
                        v-model="userData.phoneNumberDir"
                      />
                    </div>
                    <div class="col-sm-6">
                      <Field
                        name="phoneNumber"
                        type="text"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            errors.phoneNumber ||
                            (processError != null
                              ? processError.includes('phoneNumber')
                              : false),
                        }"
                        v-model="userData.phoneNumber"
                      />
                      <div class="invalid-feedback">
                        {{ errors.phoneNumber }}
                      </div>
                    </div>
                  </div>
                  <!-- Hasło -->
                  <div class="form-group row mb-3">
                    <label class="col-sm-4 col-form-label">{{ t('password') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="password"
                        type="password"
                        class="form-control"
                        :class="{ 'is-invalid': errors.password }"
                        v-model="userData.password"
                      />
                      <div class="invalid-feedback">{{ errors.password }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Komunikaty i przycisk zapisu -->
              <div class="form-group row d-flex flex-column align-items-center">
                <div class="col-auto" v-if="processError">
                  <div class="process-error form-control">
                    {{ processError }}
                  </div>
                </div>
                <div class="col-auto" v-if="processSuccess">
                  <div class="process-success form-control">
                    {{ processSuccess }}
                  </div>
                </div>
                <div class="col-auto">
                  <button
                    class="btn button-add-user"
                    :disabled="isSubmitting"
                  >
                    <span
                      v-show="isSubmitting"
                      class="spinner-border spinner-border-sm mr-1"
                    ></span>
                    {{ t('save').toUpperCase() }}
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Sekcja zmiany hasła -->
    <div class="d-flex preference-section-container">
      <div class="preference-section">
        <span>{{ t('password-change') }}</span>
      </div>
      <div class="content-wrap">
        <h3>{{ t('password-change') }}</h3>
        <div class="collapse show" id="passData">
          <div class="card-body">
            <!-- Formularz zmiany hasła -->
            <Form
              @submit="onSubmitPass"
              :validation-schema="schemaPass"
              v-slot="{ errors, isPassSubmitting }"
              :keepValues="false"
            >
              <div class="column d-flex justify-content-center user-data">
                <div class="col-sm-6">
                  <!-- Pole stare hasło -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('password') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="password"
                        type="password"
                        class="form-control"
                        v-model="form.password"
                        :class="{ 'is-invalid': errors.password }"
                      />
                      <div class="invalid-feedback">{{ errors.password }}</div>
                    </div>
                  </div>
                  <!-- Pole nowe hasło -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('new-password') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="password2"
                        type="password"
                        class="form-control"
                        v-model="form.password2"
                        :class="{ 'is-invalid': errors.password2 }"
                      />
                      <div class="invalid-feedback">{{ errors.password2 }}</div>
                    </div>
                  </div>
                  <!-- Miernik siły hasła -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('password-strength-level') }}:</label>
                    <div class="col-sm-8">
                      <password-meter :password="form.password2" />
                      <div class="d-flex password-meter center-aligned justify-content-center">
                        <div class="col-sm-4">Słabe</div>
                        <div class="col-sm-4">Średnie</div>
                        <div class="col-sm-4">Silne</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6"></div>
              </div>
              <!-- Generator haseł i przyciski -->
              <div class="column d-flex justify-content-center">
                <div class="form-group col">
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('password-proposal') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="proposed"
                        type="text"
                        class="form-control"
                        v-model="form.proposed"
                      />
                    </div>
                  </div>
                </div>
                <div class="col generate-pass">
                  <div class="form-group row">
                    <div class="col-sm-4">
                      <!-- Przycisk generowania hasła -->
                      <button
                        type="button"
                        @click="generatePassword"
                        class="btn button-add-user generate"
                      >
                        {{ t('generate').toUpperCase() }}
                      </button>
                    </div>
                    <div class="col-sm-7">
                      <!-- Przycisk wstawienia wygenerowanego hasła -->
                      <button
                        type="button"
                        @click="usePassword"
                        class="btn button-add-user use-password"
                        :disabled="!form.proposed"
                      >
                        {{ t('use-suggested-password') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row d-flex flex-column align-items-center">
                <div class="col-auto">
                  <!-- Przycisk zmiany hasła -->
                  <button
                    class="btn button-add-user"
                    :disabled="isPassSubmitting"
                  >
                    <span
                      v-show="isPassSubmitting"
                      class="spinner-border spinner-border-sm mr-1"
                    ></span>
                    {{ t('change-password') }}
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>

    <!-- Sekcja ustawień konta -->
    <div class="d-flex preference-section-container">
      <div class="preference-section">
        <span>{{ t('settings') }}</span>
      </div>
      <div class="content-wrap">
        <h3>{{ t('settings') }}</h3>
        <div class="collapse show" id="settingsData">
          <div class="card-body">
            <!-- Formularz ustawień preferencji -->
            <Form
              name="settingsForm"
              @submit="onSubmitSettings"
              :validation-schema="schemaPreferences"
              v-slot="{ errors, isSettingsSubmitting }"
            >
              <div class="column d-flex justify-content-center">
                <div class="col-sm-6">
                  <!-- Dodatkowy czas od punktu kontrolnego -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('time-from-checkpoint') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="checkpointAdditionalTime"
                        type="text"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.checkpointAdditionalTime,
                        }"
                        v-model="preferences.checkpointAdditionalTime"
                      />
                      <div class="invalid-feedback">
                        {{ errors.checkpointAdditionalTime }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6"></div>
              </div>
              <!-- Komunikaty i przycisk zapisu -->
              <div class="form-group row d-flex flex-column align-items-center mb-4">
                <div class="col-auto" v-if="processSettingsError">
                  <div class="process-error form-control">
                    {{ processSettingsError }}
                  </div>
                </div>
                <div class="col-auto" v-if="processSettingsSuccess">
                  <div class="process-success form-control">
                    {{ processSettingsSuccess }}
                  </div>
                </div>
                <div class="col-auto">
                  <button
                    class="btn button-add-user"
                    :disabled="isSettingsSubmitting"
                  >
                    <span
                      v-show="isSettingsSubmitting"
                      class="spinner-border spinner-border-sm mr-1"
                    ></span>
                    {{ t('set').toUpperCase() }}
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import * as Yup from "yup";
import { useI18n } from 'vue-i18n';
import { Form, Field } from 'vee-validate';
const { t } = useI18n();

// Schemat walidacji dla danych użytkownika
const schema = Yup.object().shape({
  firstName: Yup.string(),
  lastName: Yup.string(),
  password: Yup.string().required(t('user-password-required')),
  email: Yup.string().email(t('incorrect-email-address')),
  phoneNumber: Yup.string().required(t('user-phone-required')),
});

// Schemat walidacji dla preferencji
const schemaPreferences = Yup.object().shape({
  checkpointAdditionalTime: Yup.number(),
});

// Schemat walidacji dla zmiany hasła
const schemaPass = Yup.object().shape({
  password: Yup.string().required(t('user-password-required')),
  password2: Yup.string().required(t('user-password-required')),
});
</script>

<script>
import TopMenu from "@/components/TopMenu.vue";
import { ref } from "vue";
import PasswordMeter from "vue-simple-password-meter";
import { useErrorStore } from "@/stores/error.store";
import { useUserStore } from "@/stores/user.store";

export default {
  name: "PreferenceView",
  components: {
    TopMenu,
    PasswordMeter,
  },
  data() {
    const userStore = useUserStore();
    return {
      userStore,
      userData: {},
      preferences: {},
      form: {
        password: ref(""),
        password2: ref(""),
        proposed: ref(""),
      },
      getPasswordLength: 14,
      errorsStore: useErrorStore(),
      processSettingsSuccess: null,
      processSettingsError: null,
      processError: null,
      processSuccess: null,
    };
  },
  async mounted() {
    // Pobierz dane użytkownika po załadowaniu widoku
    await this.userStore.self();
    this.userData = this.userStore.currentUser;
    this.preferences = this.userStore.preferences;
  },
  methods: {
    // Złożenie numeru telefonu z prefixem i numerem
    getPhoneNumber: function (values) {
      return (
        (values.phoneNumberDir
          ? values.phoneNumberDir.replaceAll(" ", "")
          : "") +
        (values.phoneNumber ? values.phoneNumber.replaceAll(" ", "") : "")
      );
    },
    // Obsługa submitu dla danych użytkownika
    async onSubmit(values) {
      const userStore = useUserStore();
      const sendUser = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        password: values.password,
        phoneNumber: this.getPhoneNumber(values),
      };
      this.errorsStore.clearErrorMessage();
      const updatedData = await userStore.update(sendUser);
      if (!updatedData.error) {
        this.errorsStore.showSuccessMessage(this.$t('data-saved-correctly'));
      } else {
        this.errorsStore.showErrorMessage(updatedData.error);
      }
    },
    // Obsługa submitu dla ustawień preferencji
    async onSubmitSettings(values) {
      const userStore = useUserStore();
      this.errorsStore.clearErrorMessage();
      const sendUser = {
        checkpointAdditionalTime: parseInt(values.checkpointAdditionalTime),
      };
      const updatedData = await userStore.updateSettings(sendUser);
      if (!updatedData.error) {
        this.errorsStore.showSuccessMessage(this.$t('updated'));
      } else {
        this.errorsStore.showErrorMessage(updatedData.error);
      }
    },
    // Obsługa submitu dla zmiany hasła
    async onSubmitPass(values) {
      const userStore = useUserStore();
      const sendUser = {
        password: values.password,
        newPassword: values.password2,
      };
      this.errorsStore.clearErrorMessage();
      const updatedData = await userStore.updatePassword(sendUser);
      if (!updatedData.error) {
        this.errorsStore.showSuccessMessage(this.$t('updated'));
      } else {
        this.errorsStore.showErrorMessage(updatedData.error);
      }
    },
    // Generator silnych haseł
    generatePassword() {
      const alphabet =
        "1234567890-=!@#$%^&*()_+qazwsxedcrfvtgbyhnujmik,ol.p;/[]QAZWSXEDCRFVTGBYHNUJMIKOL>P:?{'}|";
      let pass = "";
      for (let i = 0; i < this.getPasswordLength; i++) {
        pass += alphabet[Math.floor(Math.random() * alphabet.length)];
      }
      this.form.proposed = pass;
      return pass;
    },
    // Wstawienie wygenerowanego hasła do pola
    usePassword() {
      this.form.password2 = this.form.proposed;
    },
    setup() {
      const password2 = this.form.password2;
      return {
        password2,
      };
    },
  },
};
</script>

<style scoped>
.process-error {
  color: darkred;
}

.process-success {
  color: #42b983;
}

.col-form-label {
  text-align: right;
}

.content-container > div {
  min-height: auto;
}

.content-wrap .collapse {
  margin-bottom: 20px;
}

.preference-section-container {
  width: 100%;
}

.preference-section {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

.preference-section > span {
  padding: 10px 25px;
  position: relative;
  display: block;
}

.content-wrap h3 {
  margin-bottom: 0;
  font-weight: bold;
  padding: 10px 20px;
  background-color: white;
}

.card-body .column {
  padding: 20px 30px;
}

.card-body .column > div {
  padding: 5px 20px;
}

.no-content {
  min-height: auto;
}

.icon {
  margin: 5px;
  height: 15px;
  width: 35px;
}

.icon-collapse {
  background: url("../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 10px;
}

.collapsed.icon-collapse {
  background: url("../assets/icons/rozwin.png") no-repeat left top;
}

.phone-label {
  padding-left: 0;
  padding-right: 0;
}

.password-meter {
  font-size: 12px;
}

.generate-pass {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.button-add-user {
  padding: 0.5rem 1rem 0.5rem 1rem;
}

.generate {
  padding: .75rem 2rem .75rem 2rem;
}

.use-password {
  padding: .75rem 2rem .75rem 2rem;
}
</style>
